import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["disabled", "required", "multiple", "autocomplete", "id"];
const _hoisted_2 = ["value", "disabled"];
import { ref, watch, computed } from 'vue';
import { cloneDeep } from 'lodash';
import log from "../../services/Logger";
import trans from '../../services/Translator';
import { autocompleteAttr } from "./FormUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlChoiceSelection',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = ref(null);
        const fieldOptions = computed(() => {
            return props.field.options || {};
        });
        const choices = computed(() => {
            const choices_ = [];
            if (!fieldOptions.value.required) {
                choices_.push({ value: "", label: trans('fieldOptions.no_value') });
            }
            (fieldOptions.value.choices || [])
                .forEach((choice) => choices_.push(choice));
            return choices_;
        });
        const autocomplete = computed(() => {
            return autocompleteAttr(fieldOptions.value);
        });
        updateModel();
        watch(() => props.data, updateModel);
        function updateModel() {
            model.value = createModel();
        }
        function createModel() {
            if (!props.data && props.field.options && props.field.options.multiple) {
                return [];
            }
            return cloneDeep(props.data) ?? null;
        }
        function onChange() {
            log('FieldControlChoiceSelection@change', props.field.name, model.value);
            emit('change', model.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    onChange: onChange,
                    disabled: fieldOptions.value.disabled ?? undefined,
                    required: fieldOptions.value.required ?? undefined,
                    multiple: fieldOptions.value.multiple ?? undefined,
                    autocomplete: autocomplete.value,
                    id: __props.fieldId,
                    class: "form__control"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choices.value, (choice) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: choice.value,
                            key: choice.value,
                            disabled: choice.disabled
                        }, _toDisplayString(choice.label), 9, _hoisted_2));
                    }), 128))
                ], 40, _hoisted_1), [
                    [_vModelSelect, model.value]
                ])
            ]));
        };
    }
});
